<div class="auto-ml-results">
  <app-top-stepper></app-top-stepper>
  <div class="auto-ml-results__main-heading">
    Selected variable you want to analyze
    <span>“{{ _autoMl.dependentVariable }}”</span>
  </div>
  <div class="auto-ml-results__outer">
    <div class="auto-ml-results__right-sec">
      <div class="auto-ml-results__right-inner">
        <div class="auto-ml-results__big-sec">
          <!-- <app-scenario-chart></app-scenario-chart> -->
          <div class="auto-ml-results__scn-tilewrapper">
            <div *ngFor="let item of scenarioList;let i=index" [ngClass]="{'auto-ml-results--scn-edited': i===index}" class="auto-ml-results__scn-tile" (click)="setSelected(i)">
              <div class="auto-ml-results__scn-iconsouter">
                <div class="auto-ml-results__scn-icons">
                  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                    <path d="M0 5C0 2.23858 2.23858 0 5 0H29C31.7614 0 34 2.23858 34 5V29C34 31.7614 31.7614 34 29 34H5C2.23858 34 0 31.7614 0 29V5Z" fill="#C4A577"/>
                    <path d="M7.36328 16.2391L14.5225 9.07965L19.4771 14.0344L26.6362 6.875" stroke="white" stroke-width="1.5"/>
                    <path d="M21.2676 6.87695H26.6366V12.2461" stroke="white" stroke-width="1.5"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.25977 20.4302V27.375H5.25977V20.4302H9.25977Z" fill="white"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5371 16.7358V27.375H10.5371V16.7358H14.5371Z" fill="white"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M19.8145 19.0713V27.375H15.8145V19.0713H19.8145Z" fill="white"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M25.0918 15.2658V27.375H21.0918V15.2658H25.0918Z" fill="white"/>
                  </svg>
                  <svg class="ml-2" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                    <path d="M15.2629 18.0005C16.0586 18.0005 16.7036 17.3555 16.7036 16.5598C16.7036 15.7642 16.0586 15.1191 15.2629 15.1191C14.4673 15.1191 13.8223 15.7642 13.8223 16.5598C13.8223 17.3555 14.4673 18.0005 15.2629 18.0005Z" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M16.5593 10.9399C17.355 10.9399 18 10.2949 18 9.49927C18 8.70361 17.355 8.05859 16.5593 8.05859C15.7637 8.05859 15.1187 8.70361 15.1187 9.49927C15.1187 10.2949 15.7637 10.9399 16.5593 10.9399Z" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M15.2629 3.88136C16.0586 3.88136 16.7036 3.23634 16.7036 2.44068C16.7036 1.64501 16.0586 1 15.2629 1C14.4673 1 13.8223 1.64501 13.8223 2.44068C13.8223 3.23634 14.4673 3.88136 15.2629 3.88136Z" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9.64404 13.8223H12.5254L14.244 15.5409" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9.64404 5.17952H12.5254L14.244 3.46094" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M15.1189 9.5H8.20361" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5.72785 14.7224C5.4726 15.0773 5.32227 15.5126 5.32227 15.9831C5.32227 17.1765 6.28979 18 7.48328 18C8.67678 18 9.6443 17.0325 9.6443 15.839V3.16102C9.6443 1.96752 8.67678 1 7.48328 1C6.28979 1 5.32227 1.82346 5.32227 3.01695C5.32227 3.4874 5.4726 3.92274 5.72785 4.27758" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5.4441 2.29943C5.40365 2.29767 5.36291 2.29688 5.32203 2.29688C3.73073 2.29688 2.44068 3.58682 2.44068 5.17823C2.44068 5.45812 2.48058 5.72879 2.55507 5.98465C1.65652 6.2466 1 7.07643 1 8.05959C1 8.0597 1 8.05977 1 8.05988C1.00011 8.85549 1.64506 9.50027 2.44068 9.50027M2.44068 9.50027H3.88136M2.44068 9.50027C1.64514 9.50027 1.00011 10.1451 1 10.9407C1 10.9408 1 10.9408 1 10.9409C1 11.924 1.65652 12.7538 2.55507 13.0158C2.48058 13.2717 2.44068 13.5423 2.44068 13.8223C2.44068 15.4136 3.73073 16.7037 5.32203 16.7037C5.36291 16.7037 5.40365 16.7028 5.4441 16.7011" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <div class="auto-ml-results__scn-icons">
                  <svg xmlns="http://www.w3.org/2000/svg" width="54" height="21" viewBox="0 0 54 21" fill="none">
                    <path d="M17.528 16.4039L16.5113 7.41684C16.0979 3.7628 12.9775 1 9.26418 1C5.55044 1 2.43002 3.7628 2.01706 7.41684L1 16.4039H17.528Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5.89062 16.4043C5.95888 18.4791 7.44043 20.138 9.26326 20.138C11.0857 20.138 12.5673 18.4791 12.6355 16.4043" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M43.0957 5.7832L43.0957 15.352" stroke="black" stroke-width="1.5"/>
                    <path d="M47.8789 10.5664L38.3101 10.5664" stroke="black" stroke-width="1.5"/>
                    <path d="M33.5273 4.963C33.5273 2.77429 35.3016 1 37.4903 1H48.702C50.8907 1 52.665 2.7743 52.665 4.963V16.1746C52.665 18.3633 50.8907 20.1376 48.702 20.1376H37.4903C35.3016 20.1376 33.5273 18.3633 33.5273 16.1746V4.963Z" stroke="black" stroke-width="1.5"/>
                  </svg>
                </div>
              </div>
              <div  class="auto-ml-results__scn-head">
                <span *ngIf="!item.isEdit">{{item.name}}</span>
                <input *ngIf="item.isEdit" type="text" placeholder="scenario name"  maxlength="30" [value]="item.name" [(ngModel)]="item.name" name="" id="">
              </div>
              <div class="auto-ml-results__scn-value red" [ngClass]="{'red': getPercentage(item?.prediction_output?.prediction_label,item?.default_prediction_output?.prediction_label) <0 ,'green':getPercentage(item?.prediction_output?.prediction_label,item?.default_prediction_output?.prediction_label)>0,'black':getPercentage(item?.prediction_output?.prediction_label,item?.default_prediction_output?.prediction_label)===0}">
                {{item?.prediction_output?.prediction_label|number:'1.1-1'}} 
                <span *ngIf="getPercentage(item?.prediction_output?.prediction_label,item?.default_prediction_output?.prediction_label)!==0">
                  {{'('+(getPercentage(item?.prediction_output?.prediction_label,item?.default_prediction_output?.prediction_label)>0?'+':'')+(getPercentage(item?.prediction_output?.prediction_label,item?.default_prediction_output?.prediction_label)|number:'1.1-1')+'%)'}}
                </span>
              </div>
              <div  class="auto-ml-results__scn-desc">
                <span *ngIf="!item.isEdit">{{item.description}}</span>
                <textarea *ngIf="item.isEdit" placeholder="scenario description" name="" id="" [value]="item.description" maxlength="60" [(ngModel)]="item.description"></textarea>
              </div>
              <div class="auto-ml-results__scn-bottomsec">
                <div class="auto-ml-results__scn-tag">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <line x1="13.9995" y1="3.15234" x2="6.15401" y2="3.15234" stroke="white" stroke-width="2"/>
                    <line x1="2.24316" y1="3.15234" x2="0.000175714" y2="3.15234" stroke="white" stroke-width="2"/>
                    <path d="M6.20375 3.00209C6.20375 4.09567 5.31735 4.98269 4.22315 4.98269C3.12957 4.98269 2.24316 4.09567 2.24316 3.00209C2.24316 1.90851 3.12957 1.02148 4.22315 1.02148C5.31735 1.02148 6.20375 1.90851 6.20375 3.00209Z" stroke="white" stroke-width="2"/>
                    <line x1="0.000488281" y1="9.99805" x2="7.84599" y2="9.99805" stroke="white" stroke-width="2"/>
                    <line x1="11.7568" y1="9.99805" x2="13.9998" y2="9.99805" stroke="white" stroke-width="2"/>
                    <path d="M7.79639 10.9962C7.79639 9.90265 8.68279 9.01562 9.77699 9.01562C10.8706 9.01562 11.757 9.90265 11.757 10.9962C11.757 12.0898 10.8706 12.9768 9.77699 12.9768C8.68279 12.9768 7.79639 12.0898 7.79639 10.9962Z" stroke="white" stroke-width="2"/>
                  </svg>  Scenario Drivers 
                </div>
                <a href="javascript:void(0)" class="auto-ml-results__scn-dwnload">
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="21" viewBox="0 0 23 21" fill="none">
                    <path d="M3.67191 7.64914L11.32 15.2972L18.9688 7.64844" stroke="black" stroke-width="1.5" stroke-miterlimit="10"/>
                    <path d="M21.642 16.2324C21.642 17.2835 21.2245 18.2915 20.4813 19.0347C19.7381 19.7779 18.7301 20.1954 17.679 20.1954H4.963C3.91195 20.1954 2.90394 19.7779 2.16074 19.0347C1.41753 18.2915 1 17.2835 1 16.2324" stroke="black" stroke-width="1.5" stroke-miterlimit="10"/>
                    <path d="M11.3203 15.013V1.375" stroke="black" stroke-width="1.5" stroke-miterlimit="10"/>
                  </svg>
                </a>
              </div>
              <div class="auto-ml-results__changes-sec">
                <a *ngIf="!item.isEdit" href="javascript:void(0)" class="auto-ml-results__changes-btn" (click)="editScenario(i)">
                  <img src="assets/images/svg/Edit-white.svg" alt="">
                </a>

                <a *ngIf="item.isEdit" href="javascript:void(0)" class="auto-ml-results__changes-btn" (click)="rename(item.name,item.description,item.uuid,i)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                    <path d="M1.35986 7.36131L5.10847 11.0287L11.7865 3.77539" stroke="white" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </a>

                <div class="auto-ml-results__scn-line"></div>
                <a (click)="deleteScenario(i,item.uuid)"  class="auto-ml-results__changes-btn">
                  <img src="assets/images/svg/delete-icon-white.svg" alt="">
                </a>
              </div>
            </div>
            <div (click)="addNewScenario()" class="auto-ml-results__scn-tile auto-ml-results--scn-addnew">
              <div class="auto-ml-results__add-new">
                <img src="../../../../../assets/images/svg/plus-icon2.svg" alt="">
              </div>
            </div>
          </div>
          <a
              href="javascript:void(0)"
              class="auto-ml-results__scad-btn auto-ml-results--scad-btn-primary ml-0"
            >
              Save & Complete Analysis
              <svg _ xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13" fill="none" style="margin-left: 8px;"><path _ d="M8.93059 11.4625L13.833 6.56004L8.85807 1.59961" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path _ d="M1.0113 6.53125H13.833" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg>
            </a>
        </div>
        <div class="auto-ml-results__drivers-sec">
          <div class="auto-ml-results__drivers-top">
            <div class="auto-ml-results__drivers-top-head">Download</div>
            <div class="auto-ml-results__drivers-options">
              <a
                
                class="auto-ml-results__drivers-icon"
                style="background-color: #733036"
              >
                <img src="assets/images/svg/pdf-icon.svg" alt="" />
                <span>PDF</span>
              </a>
              <a
                
                class="auto-ml-results__drivers-icon"
                style="background-color: #4c7636"
              >
                <img src="assets/images/svg/excel-icon-new.svg" alt="" />
                <span>XLS</span>
              </a>
              <a
                
                class="auto-ml-results__drivers-icon"
                style="background-color: #2b507f"
              >
                <img src="assets/images/svg/img-icon.svg" alt="" />
                <span>IMAGE</span>
              </a>
              <a
                
                class="auto-ml-results__drivers-icon"
                style="background-color: #735436"
              >
                <img src="assets/images/svg/ppt-icon.svg" alt="" />
                <span>PPT</span>
              </a>
            </div>
          </div>
          <div class="auto-ml-results__change-drivers">
            <div class="auto-ml-results__change-head-sec">
              <div class="auto-ml-results__change-head">Change drivers</div>
              <div class="auto-ml-results__change-desc">
                Modify any drivers below to view changes in the projection
              </div>
            </div>
            <div class="auto-ml-results__scroll-box">
              <div [ngClass]="{'po-none': !scenarioList[index]?.isEdit}"
                class="auto-ml-results__slider-outer"
                *ngFor="let item of driversList;let i=index"
              >
                <div class="auto-ml-results__slider-head">
                  {{ item.Feature }}
                </div>
                <div class="auto-ml-results__slider-wrap">
                  <div class="auto-ml-results__slider">
                    <span>{{ item.min_value | number : "1.1-2" }}</span>
                    <mat-slider
                      [disabled]="!scenarioList[index]?.isEdit"
                      [min]="item.min_value"
                      [max]="item.max_value"
                      [step]="getStep(item.min_value,item.max_value)"
                    >
                      <input
                        matSliderThumb
                        (change)="valueChange()"
                        [(ngModel)]="item.value"
                      />
                    </mat-slider>
                    <span>{{ item.max_value | number : "1.1-2" }}</span>
                  </div>

                  <input
                    type="number"
                    class="auto-ml-results__slider-value"
                    [min]="item.min_value"
                    [max]="item.max_value"
                    [value]="item.value"
                    [(ngModel)]="item.value"
                    (change)="setValue($event,i)"
                  />
                </div>
              </div>
            </div>
            <div [ngClass]="{'po-none': !scenarioList[index]?.isEdit}" class="auto-ml-results__btns-outer ml-2">
              <a  (click)="resetToDefault()"
                href="javascript:void(0)"
                class="auto-ml-results__scad-btn auto-ml-results--scad-btn-secondary"
              >
                RESET TO DEFAULT
              </a>
              <!-- <a
                (click)="_autoMl.runScenario()"
                href="javascript:void(0)"
                class="auto-ml-results__scad-btn auto-ml-results--scad-btn-primary"
              >
                SAVE SCENARIO
              </a> -->
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="auto-ml-results__btns-outer">
        <a
          (click)="_autoMl.saveScenarioSet()"
          href="javascript:void(0)"
          class="auto-ml-results__scad-btn auto-ml-results--scad-btn-secondary"
        >
          Add new scenario
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <path
              d="M7.1499 1.19922V13.1159"
              stroke="white"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M13.1 7.14844H1.19995"
              stroke="white"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>
        <a
          href="javascript:void(0)"
          class="auto-ml-results__scad-btn auto-ml-results--scad-btn-primary"
        >
          Save & Complete Analysis
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="13"
            viewBox="0 0 15 13"
            fill="none"
          >
            <path
              d="M8.89763 11.4625L13.8 6.56004L8.82511 1.59961"
              stroke="#3267FF"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M0.978345 6.53125H13.8"
              stroke="#3267FF"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>
      </div> -->
    </div>
  </div>
</div>
